import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import { KineticLines } from "@/components/Reveal";
import { IMG } from "@/lib/images";
import { track } from "@/lib/track";

const EASE = [0.16, 1, 0.3, 1];

const fadeUp = (delay) => ({
  initial: { opacity: 0, y: 26 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: EASE },
});

export default function Hero() {
  return (
    <section data-testid="home-hero" className="relative overflow-hidden bg-cream">
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 pb-14 pt-24 md:px-10 md:pb-20 md:pt-36 lg:grid-cols-12 lg:items-center lg:gap-8">
        <div className="lg:col-span-5 lg:order-1">
          <motion.p {...fadeUp(0.05)} className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-rific md:text-xs">
            Ice Cream • Desserts • Shakes
          </motion.p>
          <h1 className="mt-5">
            <KineticLines
              mode="load"
              lines={["RIFIC"]}
              className="block"
              lineClassName="font-display text-[clamp(2.875rem,6vw,5.5rem)] font-extrabold leading-[0.98] tracking-[-0.01em] text-deep"
            />
            <KineticLines
              mode="load"
              delay={0.25}
              lines={["REAL TASTES", "BETTER."]}
              stagger={0.12}
              className="mt-3 block"
              lineClassName="font-display text-[clamp(1.75rem,3.8vw,3.5rem)] font-bold leading-[1.04] tracking-[-0.01em] text-orange-rific"
            />
          </h1>
          <motion.p {...fadeUp(0.6)} className="mt-6 max-w-md text-base leading-relaxed text-deep/75 md:text-lg">
            Real ingredients. Serious ice cream.
          </motion.p>
        </div>

        <motion.div {...fadeUp(0.28)} className="lg:col-span-7 lg:order-2 lg:row-span-2">
          <div className="overflow-hidden rounded-[28px] bg-cream lg:rounded-[40px]">
            <img
              src={IMG.heroMaster}
              srcSet={`${IMG.heroMaster} 1672w, ${IMG.heroMasterM} 900w`}
              sizes="(min-width: 1024px) 58vw, 100vw"
              alt="RIFIC Alphonso mango ice cream — real fruit, real milk"
              className="h-auto w-full object-contain"
              fetchPriority="high"
            />
          </div>
        </motion.div>

        <motion.div {...fadeUp(0.72)} className="flex flex-wrap items-center gap-3 md:gap-4 lg:order-3 lg:col-span-5">
          <Link
            to="/menu"
            data-testid="hero-cta-explore"
            className="inline-flex h-14 items-center gap-2 whitespace-nowrap rounded-full bg-deep px-8 text-sm font-bold uppercase tracking-[0.16em] text-cream transition-all duration-300 hover:bg-orange-rific hover:text-white"
          >
            Explore RIFIC
            <ArrowDown className="h-4 w-4" />
          </Link>
          <Link
            to="/franchise#franchise-form"
            data-testid="hero-cta-franchise"
            onClick={() => track("franchise_cta_click", { placement: "hero" })}
            className="inline-flex h-14 items-center gap-2 whitespace-nowrap rounded-full bg-orange-rific px-8 text-sm font-bold uppercase tracking-[0.16em] text-white transition-all duration-300 hover:bg-deep"
          >
            Own a RIFIC
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
